angular.module('bribac.entities.kinds', [])

  .constant('KINDS', (function() {
    var MAIN_GROUP = 'mainGroup'
    var SUB_GROUP = 'subGroup'
    var SUBJECT = 'subject'
    var SCHEDULE = 'schedule'
    var SCHEDULE_PERIOD = 'schedulePeriod'
    var AGENT = 'agent'
    var TEST = 'test'
    var IBAC = 'ibac'
    var NOTE = 'note'
    var RULE_SET = 'ruleSet'
    var SAMPLE = 'sample'
    var PHOTO = 'photo'
    var ORGANIZATION = 'organization'
    var MESSAGE = 'message'
    var ALERTS = 'alerts'
    var ASSIGNABLE_IBACS = 'assignableIbacs'
    var BOOST_IMAGE = 'boostImage'
    var INACTIVE_DAYS = 'inactiveDays'
    var DELETE_INACTIVE_DAYS = 'deleteInactiveDay'
    var FACE_RECOGNITION = 'faceRecognition'
      var SUBJECTS_UPLOAD = 'subjectsUpload'
      var INSURANCE_PROVIDER = 'insuranceProvider'
      var INSURANCE_COMPANY = 'insuranceCompany'
      var INSURANCE_SUBSCRIBER = 'insuranceSubscriber'

    // Can be used as an array to get all kinds.

    var KINDS = [
      MAIN_GROUP,
      SUB_GROUP,
      SUBJECT,
      SCHEDULE,
      SCHEDULE_PERIOD,
      AGENT,
      TEST,
      IBAC,
      NOTE,
      RULE_SET,
      SAMPLE,
      PHOTO,
      ORGANIZATION,
      MESSAGE,
      ALERTS,
      ASSIGNABLE_IBACS,
      BOOST_IMAGE,
      INACTIVE_DAYS,
      DELETE_INACTIVE_DAYS,
      FACE_RECOGNITION,
        SUBJECTS_UPLOAD,
        INSURANCE_PROVIDER,
        INSURANCE_COMPANY,
        INSURANCE_SUBSCRIBER
    ]

    // Can be used as an object to get a specific kind.

    KINDS.MAIN_GROUP = MAIN_GROUP
    KINDS.SUB_GROUP = SUB_GROUP
    KINDS.SUBJECT = SUBJECT
    KINDS.SCHEDULE = SCHEDULE
    KINDS.SCHEDULE_PERIOD = SCHEDULE_PERIOD
    KINDS.AGENT = AGENT
    KINDS.TEST = TEST
    KINDS.IBAC = IBAC
    KINDS.NOTE = NOTE
    KINDS.RULE_SET = RULE_SET
    KINDS.SAMPLE = SAMPLE
    KINDS.PHOTO = PHOTO
    KINDS.ORGANIZATION = ORGANIZATION
    KINDS.MESSAGE = MESSAGE
    KINDS.ALERTS = ALERTS
    KINDS.ASSIGNABLE_IBACS = ASSIGNABLE_IBACS
    KINDS.BOOST_IMAGE = BOOST_IMAGE
    KINDS.INACTIVE_DAYS = INACTIVE_DAYS
    KINDS.DELETE_INACTIVE_DAYS = DELETE_INACTIVE_DAYS
    KINDS.FACE_RECOGNITION = FACE_RECOGNITION
      KINDS.SUBJECTS_UPLOAD = SUBJECTS_UPLOAD
      KINDS.INSURANCE_PROVIDER = INSURANCE_PROVIDER
      KINDS.INSURANCE_COMPANY = INSURANCE_COMPANY
      KINDS.INSURANCE_SUBSCRIBER = INSURANCE_SUBSCRIBER

    // Only some of the kinds may have all its entities listed.

    KINDS.mayBeListed = [
      MAIN_GROUP,
      AGENT,
      SUBJECT,
      SCHEDULE,
      RULE_SET
    ]

    return KINDS
  }()))
